"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHighlightedOption = void 0;
var react_1 = require("react");
var useHighlightedOption = function (configuration) {
    var _a = react_1.useState(null), highlightedEl = _a[0], setHighlightedEl = _a[1];
    var scrollIntoView = react_1.useRef(true);
    var _b = react_1.useState(), highlightedOption = _b[0], setHighlightedOption = _b[1];
    react_1.useEffect(function () {
        if (scrollIntoView.current && highlightedEl && highlightedEl.parentElement) {
            var parentRect = highlightedEl.parentElement.getBoundingClientRect();
            var highlightedRect = highlightedEl.getBoundingClientRect();
            if (highlightedRect.bottom > parentRect.bottom) {
                highlightedEl.scrollIntoView(false);
            }
            else if (highlightedRect.top < parentRect.top) {
                highlightedEl.scrollIntoView(true);
            }
        }
        scrollIntoView.current = false;
    }, [highlightedEl]);
    var highlightNextOption = function (direction) {
        var options = configuration.options;
        if (!highlightedOption && options.length) {
            if (direction === "ArrowUp") {
                setHighlightedOption(options[options.length - 1]);
            }
            else {
                setHighlightedOption(options[0]);
            }
        }
        else {
            var currentlyHighlightedIndex = options.findIndex(function (option) { return option === highlightedOption; });
            var indexToHighlight = 0;
            if (direction === "ArrowUp") {
                indexToHighlight = currentlyHighlightedIndex - 1;
                if (indexToHighlight < 0) {
                    // First item was highlighted, roll over to bottom
                    indexToHighlight = options.length - 1;
                }
            }
            else {
                indexToHighlight = currentlyHighlightedIndex + 1;
                if (indexToHighlight === options.length) {
                    // Last item highlighted, roll over to top
                    indexToHighlight = 0;
                }
            }
            setHighlightedOption(options[indexToHighlight]);
            scrollIntoView.current = true;
        }
    };
    var removeHighlight = function () { return setHighlightedOption(undefined); };
    return {
        highlightedOption: highlightedOption,
        highlightOption: setHighlightedOption,
        removeHighlight: removeHighlight,
        highlightNextOption: highlightNextOption,
    };
};
exports.useHighlightedOption = useHighlightedOption;
//# sourceMappingURL=useHighlightedOption.js.map